import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { ListChecks } from 'lucide-react';
import SectionMasterDataManager from './SectionMasterDataManager';

const TITLES = {
  allowance: { title: 'Allowances', description: 'Standard allowance names used in Summary Audit Reports' },
  management: { title: 'Management Items', description: 'Standard management item names used in Summary Audit Reports' },
  adjustment: { title: 'Adjustments', description: 'Standard adjustment names used in Summary Audit Reports' },
};

/**
 * "Manage list" pop-up opened from within the Summary Audit Report wizard —
 * gives the exact same CRUD functionality as the full Master Data page,
 * without leaving the wizard.
 */
export default function ManageMasterListDialog({ open, onOpenChange, category, onItemsChanged }) {
  const meta = TITLES[category] || { title: 'Master List', description: '' };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid={`manage-${category}-list-dialog`}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ListChecks className="h-5 w-5" />
            Manage {meta.title}
          </DialogTitle>
          <DialogDescription>{meta.description}</DialogDescription>
        </DialogHeader>
        <SectionMasterDataManager category={category} title={meta.title} onItemsChanged={onItemsChanged} />
      </DialogContent>
    </Dialog>
  );
}
